import { TimeReportExcelRow } from '@app/shared/types/models/reports/time-report-excel-row.model';
import { ReportColumnsEnum } from '@app/shared/types/models/reports/time-report-panel.model';
import moment from 'moment';

export interface TimeReportExcelFormatContext {
  locale: string;
  formatDuration: (isoDuration: string) => string | number;
}

export function durationToDecimalFormat(duration: string | undefined): string {
  if (!duration) return '0,00';

  const match = duration.match(/PT(?:(\d+)H)?(?:(\d+)M)?/);
  if (!match) return '0,00';

  const hours = parseInt(match[1] || '0', 10);
  const minutes = parseInt(match[2] || '0', 10);

  const decimalPart = Math.round((minutes / 60) * 100);

  return `${hours},${decimalPart.toString().padStart(2, '0')}`;
}

export function formatExcelDate(date: Date | undefined): string {
  return date ? moment(date).format('YYYY-MM-DD') : '';
}

export function formatExcelMonth(date: Date | undefined, locale: string): string {
  return date ? new Intl.DateTimeFormat(locale, { month: 'long' }).format(new Date(date)) : '';
}

export function formatExcelWeek(date: Date | undefined): number | '' {
  return date ? moment(date).isoWeek() : '';
}

export function excelCellValue(
  row: TimeReportExcelRow,
  column: ReportColumnsEnum,
  context: TimeReportExcelFormatContext
): unknown {
  switch (column) {
    case ReportColumnsEnum.DATE:
      return formatExcelDate(row.date);
    case ReportColumnsEnum.MONTH:
      return formatExcelMonth(row.date, context.locale);
    case ReportColumnsEnum.WEEK:
      return formatExcelWeek(row.date);
    case ReportColumnsEnum.USER:
      return row.user;
    case ReportColumnsEnum.COMPANY:
      return row.company;
    case ReportColumnsEnum.PROJECT:
      return row.project;
    case ReportColumnsEnum.TASK_ID:
      return row.taskId;
    case ReportColumnsEnum.TASK_LINK:
      return row.taskLink;
    case ReportColumnsEnum.TASK_TITLE:
      return row.taskTitle;
    case ReportColumnsEnum.LOCATION:
      return row.location;
    case ReportColumnsEnum.DESCRIPTION:
      return row.description;
    case ReportColumnsEnum.TYPE:
      return row.type;
    case ReportColumnsEnum.TOTAL:
      return row.duration;
    case ReportColumnsEnum.DECIMAL_HOURS:
      return durationToDecimalFormat(row.duration);
    case ReportColumnsEnum.ESTIMATION:
      return row.estimation ? context.formatDuration(row.estimation) : '';
    case ReportColumnsEnum.STATUS:
      return row.status;
    default:
      return '';
  }
}
